import React from 'react';
import { useIsMobile, useT } from '@repo/common';
import ExperienceForm from './Experience/ExperienceForm';
import ExperienceBanner from './Experience/ExperienceBanner';
import StepTitle from '../Common/StepTitle';
import MobileExperienceForm from './Experience/MobileExperienceForm';

const ExperienceStep = ({ resumeData, setResumeData }) => {
  const t = useT();
  const isMobile = useIsMobile();

  return (
    <div>
      <div className='w-full flex flex-col items-start'>
        {isMobile && (
          <div className='pb-4'>
            <ExperienceBanner $isMobile={isMobile} />
          </div>
        )}
        <StepTitle
          title={t('Experience (Paid or Formal Work)', '경력 (유급 또는 공식 업무)')}
          $isMobile={isMobile}
        />
        <div className='w-full flex items-start'>
          {isMobile ? (
            <MobileExperienceForm
              experience={resumeData.experience}
              setResumeData={setResumeData}
              $isMobile={isMobile}
            />
          ) : (
            <div className='flex-1 pr-6'>
              <ExperienceForm
                experience={resumeData.experience}
                setResumeData={setResumeData}
              />
            </div>
          )}
          {!isMobile && <ExperienceBanner />}
        </div>
      </div>
    </div>
  );
};

export default ExperienceStep;
